import Vue from 'vue';
import App from './App.vue';
import store from './store';

import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

Bugsnag.start({
	apiKey: 'a37c83cfd51038657eb7780e127d9e52',
	plugins: [new BugsnagPluginVue()]
});

// TODO remove following ?
import Vue2TouchEvents from 'vue2-touch-events';
Vue.use(Vue2TouchEvents);

Vue.config.productionTip = false;

// DECLARATION
Vue.filter('dynamicList', function(value: string): any {
	// eslint-disable-next-line no-useless-escape
	return value.replace(/{{\s*[\w\.]+\s*}}/g, '');
});

new Vue({
	store,
	render: h => h(App)
}).$mount('#app');

let BugSnagPI: any = Bugsnag.getPlugin('vue');
BugSnagPI.installVueErrorHandler(Vue);
